<script setup>
import { useField } from 'vee-validate';
import Checkbox from 'components/Checkbox.vue';

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  verticalCentered: {
    type: Boolean,
    default: true
  },
  showLabel: {
    type: Boolean,
    default: true
  },
  partiallyChecked: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false,
  }
});

const { value, errorMessage } = useField(
  props.name,
  props.required ? 'required' : undefined,
  {
    label: props.label ?? props.name,
  }
);
</script>

<template>
  <checkbox
    :id="id"
    class="ce-field"
    :class="{ invalid: !!errorMessage }"
    v-model="value"
    :vertical-centered="verticalCentered"
    :show-label="showLabel"
    :partially-checked="partiallyChecked">
    <slot />
  </checkbox>
</template>
